﻿function initComponentsTextAndImage() {
    const allTextAndImageComponents = gsap.utils.toArray('[data-scrollTrigger]');
    if (allTextAndImageComponents.length > 0) {
        for (const component of allTextAndImageComponents) {
            //First we determine direction. The template will apply a class to help us here.
            const direction = component.querySelector('.image_left') != null ? '-75' : '75';
            //Then grab the image we're animating
            const image = component.querySelector('img')
            //finally we create a scrollTrigger
            gsap.from(image, {opacity: 0, x: direction, scrollTrigger: {
                              trigger: component,
                              start: 'top 70%',
                              }})
        }
    }
}

initComponentsTextAndImage();